import { Send } from 'lucide-react';
import CustomSelect from '../../../../../../components/forms/CustomSelect';
import CustomInput from '../../../../../../components/forms/CustomInput';
import FeatureLocked from '../../../../../../components/gating/FeatureLocked';
import { postTripData } from '../../../../utils/postTripHelpers';

const CustomBroadcast = ({
    customForm,
    setCustomForm,
    onSendCustom,
    isNotificationsLocked
}) => {
    const targetOptions = postTripData.broadcastTargetOptions || [];

    return (
        <div className="relative min-h-[480px] pb-4">
            <div className={`bg-white border border-slate-200 rounded-2xl p-6 w-full shadow-sm space-y-4 ${isNotificationsLocked ? 'opacity-70 pointer-events-none select-none' : ''}`}>
                <h3 className="font-bold text-slate-800 text-lg">Send Custom Notification</h3>
                <form onSubmit={onSendCustom} className="space-y-4">
                    <div>
                        <CustomSelect
                            label="Recipients"
                            value={customForm.target}
                            onChange={(val) => setCustomForm({ ...customForm, target: val })}
                            options={targetOptions}
                            placeholder="Select Recipients"
                        />
                    </div>

                    <div>
                        <CustomInput
                            label="Title"
                            type="text"
                            disabled={isNotificationsLocked}
                            value={customForm.title}
                            onChange={(e) => setCustomForm({ ...customForm, title: e.target.value })}
                            placeholder="Notification title..."
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5">Message</label>
                        <textarea
                            rows={3}
                            disabled={isNotificationsLocked}
                            value={customForm.message}
                            onChange={(e) => setCustomForm({ ...customForm, message: e.target.value })}
                            placeholder="Message content..."
                            className="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#067978]/20 focus:border-[#067978]"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isNotificationsLocked}
                        className="w-full py-2.5 bg-[#067978] text-white text-sm font-semibold rounded-xl hover:bg-[#056362] transition-colors cursor-pointer flex items-center justify-center gap-2"
                    >
                        <Send size={16} />
                        Send Now
                    </button>
                </form>
            </div>

            {isNotificationsLocked && (
                <FeatureLocked featureKey="notifications" overlay={true} />
            )}
        </div>
    );
};

export default CustomBroadcast;
